import { useCheckAuth, usePermissions } from "ra-core";
import { useEffect } from "react";
import { Permissions_new } from "~/constants";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { useSnackbar } from "notistack";


// requiredPermissionsGroups = [pGroup1, pGroup2, ...] # pGroup1 OR pGroup2 ...
// pGroup = [p1, p2, ...]                              # p1 AND p2 ...
const usePermitGuard = (requiredPermissionsGroups: Permissions_new[][]) => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const checkAuth = useCheckAuth()
  const { loaded, permissions } = usePermissions()
  const permits: Permissions_new[] = permissions

  useEffect(() => {
    checkAuth()
  }, [])

  useEffect(() => {
    if (loaded) {
      const blockAccess = () => {
        dispatch(push('/dashboard'))
        enqueueSnackbar('Permission denied.', { variant: 'warning' })
      }

      const anySatisfied = 
        requiredPermissionsGroups
          .map(requiredGroup => requiredGroup.every(rp => permits.indexOf(rp) > -1))
          .reduce((a, b) => a || b)
      if (!anySatisfied) { blockAccess() }
    }
  }, [loaded, permits])
}

export default usePermitGuard;
